import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { AdminBoardComponent } from './composants/admin-board/admin-board.component';
import { UserBoardComponent } from './composants/user-board/user-board.component';
import { SupervisorBoardComponent } from './composants/supervisor-board/supervisor-board.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    AdminBoardComponent,
    UserBoardComponent,
    SupervisorBoardComponent,
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule
  ]
})
export class DashboardModule { }
